import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import Essence from "@/pages/Essence";
import SurvivalMechanism from "@/pages/SurvivalMechanism";
import Superpower from "@/pages/Superpower";
import Signup from "@/pages/Signup";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    // Smooth-scroll for in-page anchor links
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onClick);

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;

    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/creatingwealth" element={<Landing />} />
        <Route path="/essence" element={<Essence />} />
        <Route path="/survivalmechanism" element={<SurvivalMechanism />} />
        <Route path="/superpower" element={<Superpower />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="*" element={<Navigate to="/creatingwealth" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
